import { axiosClient } from '@/lib/axios';
import { MutationFunction, useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { VerificationData } from '../types';
import { AxiosError } from 'axios';

type RequestOTPResponse = {
  data: {
    message: 'string';
  };
};

const requestNewOTP = async (verificationData: Omit<VerificationData, 'code'>): Promise<RequestOTPResponse> => {
  const { data } = await axiosClient.post<RequestOTPResponse>('/auth/request-otp', verificationData);
  return data;
};

type UseRequestOTPDTO = {
  config?: MutationFunction<typeof requestNewOTP>;
  handleAfterSuccess: () => void;
  handleAfterFailure: (code?: number) => void;
};

export const useRequestOTP = ({ config, handleAfterSuccess, handleAfterFailure }: UseRequestOTPDTO) => {
  const { notification: toaster } = App.useApp();

  return useMutation({
    onError: (error: AxiosError<{ message: string }>) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data.message,
      });
      handleAfterFailure(error.response?.status);
    },
    onSuccess: async (res) => {
      toaster.success({
        message: 'OTP sent',
        description: res.data.message,
      });
      handleAfterSuccess();
    },
    ...config,
    mutationFn: requestNewOTP,
  });
};
